import { render, staticRenderFns } from "./AccentHeader.vue?vue&type=template&id=2fbc06c9&scoped=true"
import script from "./AccentHeader.vue?vue&type=script&lang=js"
export * from "./AccentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc06c9",
  null
  
)

export default component.exports